import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { Observable } from 'rxjs';
import { DropDownListDTO, DropDownListSiteRecebimentoDTO } from 'src/app/entity/dto/dropdownlist.component';
import { map, startWith, take } from 'rxjs/operators';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-sec002-card-I',
    templateUrl: './sec002-card-I.component.html'
})

export class Sec002CardIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listSiteRecebimento?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public listSiteRecebimentoOriginal?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public listSiteOrigem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSiteOrigemOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listHibrido?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSecCamara?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTipoColheita?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listHouveTrocaCaixa?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listNCaixa?: any[] = [];

    public filteredOptionsSiteRecebimento: Observable<DropDownListSiteRecebimentoDTO[]>;
    public filteredOptionsSiteOrigem: Observable<DropDownListDTO[]>;
    public filteredOptionsHibrido: Observable<DropDownListDTO[]>;
    public filteredOptionsSecCamara: Observable<DropDownListDTO[]>;
    public filteredOptionsTipoColheita: Observable<DropDownListDTO[]>;
    public filteredOptionsHouveTrocaCaixa: Observable<DropDownListDTO[]>;

    public isReadyOnly: boolean;
    public isEdit: boolean = false;
    public isHouveTroca: boolean = false;


    public disableNumeroCampo: boolean = false;
    public safraBasicaOld = ''


    @Output() mkCalc = new EventEmitter();
    @Output() objQua007 = new EventEmitter();
    @Output() objQua007PreBasica = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Dados Iniciais da Câmara', false);
        if (this.isComercial) {
            this.formulario = this.formBuilder.group({
                Site_recebimento: [null, []],
                Site_origem: [null, []],
                Safra: [null, [Validators.pattern(this.regexSafra)]],
                // Controle_secagem: [null, [Validators.pattern('\^[0-9\;]+$')]],
                // Secador_camara: [null, [Validators.pattern('\^([DGC]{1}[0-9]{1}[\.]{1}[0-9]{2})$|([DGC]{1}[0-9]{1}[\.][0-9]{2}[;]{1})+([DGC]{1}[0-9]{1}[\.][0-9]{2}[;]?)')]],
                Tipo_colheita: [null, []],
                Contrato_campo: [null, []],
                Contrato_campo_2: [null, []],
                Num_campo: [null, []],
                Hibrido_rnc_linhagem: [null, []],
                Geracao: [null, []],
                Especie: [null, []],
                Inicio_enchimento_data: [null, [Validators.pattern(this.regexDate)]],
                Inicio_enchimento_hora: [null, [Validators.pattern(this.regexHour)]],
                Termino_enchimento_data: [null, [Validators.pattern(this.regexDate)]],
                Termino_enchimento_hora: [null, [Validators.pattern(this.regexHour)]],
                Peso_rw_kg_total: [null, []],
                // Altura_camada_m: [null, [Validators.max(4.50)]],
                Umidade_media_cerar: [null, []],
            });
        } else if (this.isBasica) {
            this.formulario = this.formBuilder.group({
                Site_recebimento: [null, []],
                Site_origem: [null, []],
                Safra: [null, [Validators.pattern(this.regexSafra)]],
                // Controle_secagem: [null, [Validators.pattern('\^[0-9\;]+$')]],
                // Secador_camara: [null, [Validators.pattern('\^([DGC]{1}[0-9]{1}[\.]{1}[0-9]{2})$|([DGC]{1}[0-9]{1}[\.][0-9]{2}[;]{1})+([DGC]{1}[0-9]{1}[\.][0-9]{2}[;]?)')]],
                Tipo_colheita: [null, []],
                Contrato_campo: [null, []],
                Contrato_campo_2: [null, []],
                Num_campo: [null, []],
                Hibrido_rnc_linhagem: [null, []],
                Geracao: [null, []],
                Especie: [null, []],

                gleba: [null, [Validators.required]],

                Inicio_enchimento_data: [null, [Validators.pattern(this.regexDate)]],
                Inicio_enchimento_hora: [null, [Validators.pattern(this.regexHour)]],
                Termino_enchimento_data: [null, [Validators.pattern(this.regexDate)]],
                Termino_enchimento_hora: [null, [Validators.pattern(this.regexHour)]],
                Peso_rw_kg_total: [null, []],
                Altura_camada_m: [null, []],
                Umidade_media_cerar: [null, []],
            });

        } else if (this.isPreBasica) {
            this.formulario = this.formBuilder.group({
                site_recebimento: [null, [Validators.nullValidator]],
                safra: [null, [Validators.pattern(this.regexSafra), Validators.required]],
                safra_basica: [null, [Validators.pattern(this.regexSafraPreBasica), Validators.required]],
                cerar_basica: [null, [Validators.required]],
                n_de_campo_basica: [null, [Validators.required]],
                gleba: [null, []],
                geracao_basica: [null, [Validators.required]],
                numero_caixa: [null, [Validators.required]],
                // controle_secagem: [null, [Validators.required]],
                lote_rw: [null, []],
                umidade_recebimento: [null, [Validators.required]],
                tipo_colheita: ['Espiga', [Validators.required]],
                contrato_campo: [null, [Validators.required]],
                hibrido_rnc_linhagem: ['', [Validators.required]],
                cooperante: [null, [Validators.required]],
                peso_rw_kg_total: [null, [Validators.required]],
                // Altura_camada_m: [null, [Validators.required]],
                nota_ardida: [null, [Validators.required]],
                houve_troca_caixa: [null, [Validators.required]],
                numero_novo_caixa: [null, []],
                controle_caixa: [null, [Validators.required]],
            });
        }

    }

    public async ngOnInit(): Promise<void> {
        this.isReadyOnly = true;
        await this.getLists();

        const siteRecebimento = this.generalService.getLocalStorageDataSite();
        const field = this.isPreBasica ? 'site_recebimento' : 'Site_recebimento';
        this.formulario.get(field).setValue(siteRecebimento);

    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
        await Promise.all([this.getListSiteRecebimento(), this.getListHouveTrocaCaixa()]);
    }

    async getFilters(): Promise<void> {
        // await this.createFilterHibrido();
        // await this.createFilterSecCamara();
        // await this.createFilterTipoColheita();
    }

    async getListSiteRecebimento(): Promise<void> {
        this.listSiteRecebimento = this.generalService.getListSiteRecebimento();
        this.listSiteRecebimentoOriginal = this.listSiteRecebimento;
    }

    async getListSiteOrigem(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'Site_Origem').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listSiteOrigem = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listSiteOrigemOriginal = this.listSiteOrigem;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiteOrigem);
        });
    }

    async createFilterSiteOrigem(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listSiteOrigemOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listSiteOrigem = this.listSiteOrigemOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listSiteOrigem = this.listSiteOrigemOriginal;
            }
        } else {
            this.listSiteOrigem = this.listSiteOrigemOriginal;
        }
    }

    async getListHibrido(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'hibrido_rnc').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listHibrido = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorHibrido);
        });
    }
    async getListHouveTrocaCaixa(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'houve_troca_caixa').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listHouveTrocaCaixa = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorHibrido);
        });
    }

    async createFilterSiteRecebimento(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listSiteRecebimentoOriginal.filter(x => x.initials?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listSiteRecebimento = this.listSiteRecebimentoOriginal.filter(x => x.initials?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listSiteRecebimento = this.listSiteRecebimentoOriginal;
            }
        } else {
            this.listSiteRecebimento = this.listSiteRecebimentoOriginal;
        }
    }

    async getListTipoColheita(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'tipo_colheita').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listTipoColheita = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTipoColheita);
        });
    }

    createFilterHibrido(): void {
        this.filteredOptionsHibrido = this.formulario.get('Hibrido_rnc_linhagem').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listHibrido, value))
            );
    }

    createFilterTipoColheita(): void {
        this.filteredOptionsTipoColheita = this.formulario.get('Tipo_colheita').valueChanges
            .pipe(
                startWith(''),
                map(value => this.generalService._filterDropDownList(this.listTipoColheita, value))
            );
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    async getQua007Data(value?: any): Promise<void> {
        this.objQua007.emit();
    }

    updateFields(event: any): void {
        if (this.formulario?.get('safra_basica').value &&
            this.formulario?.get('n_de_campo_basica').value &&
            this.formulario?.get('safra_basica').value.length === 5 &&
            this.formulario?.get('cerar_basica').value &&
            this.formulario?.get('numero_caixa').value) {
            this.objQua007PreBasica.emit();
        }
    }

    changeSafra(event: any): void {
        const safraBasica = (this.formulario.get('safra_basica')?.value as string)?.toUpperCase()
        const prefix = safraBasica.substring(0, 2); // Pega o prefixo (IN ou VE)
        const year = safraBasica.substring(3); // Pega o ano (22)
        if ((!safraBasica.includes('INV') && !safraBasica.includes('VER'))) {
            this.formulario.get('safra_basica')?.setErrors({ pattern: false })
            this.formulario.get('safra_basica').updateValueAndValidity()

            return
        }
        console.log(safraBasica)
        console.log(`${prefix}${year}`)
        this.formulario.get('safra')?.setValue(`${prefix}${year}`)


        this.formulario.get('safra_basica')?.setValue(safraBasica)

        this.formulario.get('safra_basica')?.setErrors({ pattern: true })
        this.formulario.get('safra_basica').updateValueAndValidity()

        if (safraBasica != "" || safraBasica != null) {

            this.disableNumeroCampo = this.safraBasicaOld == safraBasica
        }
        this.updateFields(null)


    }

    changeHouveTroca() {
        const houveTrocaCaixa = this.formulario.get('houve_troca_caixa').value as string
        this.isHouveTroca = houveTrocaCaixa.toUpperCase() === 'SIM' ? true : false
    }

    async checkNumeroCampo() {
        const site = this.formulario.get('site_recebimento')?.value
        const safra = this.formulario.get('safra_basica')?.value
        const numeroCampo = this.formulario.get('n_de_campo_basica')?.value
        const numeroCaixa = this.formulario.get('numero_caixa')?.value
        if (!site || !safra || !numeroCampo || !numeroCaixa || this.disableNumeroCampo) {
            return
        }
        this.formularioService.checkNumeroCampo('sec002', {
            filters: {
                n_de_campo_basica: String(numeroCampo),
                site_recebimento: site as string,
                safra_basica: safra as string,
                numero_caixa: String(numeroCaixa)
            }
        }).pipe(take(1)).toPromise().then((response: any) => {

            if ((response.data as boolean) === true) {
                this.formulario.get('numero_caixa').setErrors({ invalidExist: true });;
                this.notificationService.sendNotification(`O Numero Caixa ${numeroCampo} já está cadastrado na base de dados, favor inserir outro.`, TypeMessage.Personalized, ActionMessage.Info);
            } else {
                this.formulario.get('numero_caixa').setErrors({ invalidExist: false });
                this.formulario.get('numero_caixa').updateValueAndValidity();
                this.updateFields(null)
            }

        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

}

